import React from "react";
import "./CopyRight.modules.css";
import { useTranslation } from "react-i18next";

const CopyRight = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="copy-right py-5">
        <div className="container">
          <p>
            <a
              href="https://brmja.tech/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("copyright")}
            </a>
          </p>{" "}
        </div>
      </div>
    </>
  );
};

export default CopyRight;
